//@flow
import SV from 'server-vars';

type Image = {
    +height: ?number,
    +width: ?number,
};

type flagsType = {
    isMobile: ?boolean,
    isTablet: ?boolean,
    isDesktop: ?boolean,
};

// tablet sizes are 2x the 12" ipad pro
export const HEIGHT_DEFAULT = 1500;
export const HEIGHT_TABLET = 2732;
export const HEIGHT_MOBILE = 1624;

export const WIDTH_MOBILE = 830;
export const WIDTH_TABLET = 2048;

export function getImageSizeParam(image: ?Image, _flags?: flagsType): string {
    let isDesktop = SV.get('settings.isDesktop');
    let isMobile = SV.get('settings.isMobile');
    let isTablet = SV.get('settings.isTablet');

    if (!image) {
        return '';
    }
    const { height, width } = image;

    if (!width || !height) {
        return '';
    }

    // istanbul ignore else
    if (_flags) {
        isDesktop = _flags.isDesktop;
        isMobile = _flags.isMobile;
        isTablet = _flags.isTablet;
    }

    // Desktop only constrains the height
    if (isDesktop || (!isMobile && !isTablet)) {
        return `?height=${HEIGHT_DEFAULT}`;
    }

    const isPortrait = height > width;
    const dimension = isPortrait ? 'height' : 'width';

    let _w = WIDTH_MOBILE;
    let _h = HEIGHT_MOBILE;

    if (isTablet) {
        _w = WIDTH_TABLET;
        _h = HEIGHT_TABLET;
    }

    return `?${dimension}=${isPortrait ? _h : _w}`;
}

export default getImageSizeParam;
